import Vue from "vue";
import Vuex from "vuex";

import forms from "./modules/forms";
import users from "./modules/users/users";
import auth from "./modules/users/auth";
import utilities from "./modules/helpers/utilities";
import companies from "./modules/companies";
import notifications from "./modules/helpers/notifications";
import goals from "./modules/goals";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { forms, users, auth, utilities, notifications, companies, goals }
});
